var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorimg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 77,
    viewBox: "0 0 351 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.505 0.57251C294.836 0.57251 279.551 15.0842 277.382 33.742C277.382 33.742 277.382 33.742 277.349 33.742C227.224 37.8882 78.1943 38.296 19.2926 34.3877C17.8135 30.6154 14.2308 27.9306 10.0564 27.9306C4.53434 27.9306 0.03125 32.5865 0.03125 38.296C0.03125 44.0056 4.53434 48.6615 10.0564 48.6615C14.2308 48.6615 17.7806 46.0107 19.2926 42.2723C86.1487 38.296 219.664 38.7039 277.382 42.884C277.382 42.884 277.382 42.884 277.415 42.884C279.617 61.5419 294.901 76.0196 313.538 76.0196C333.687 76.0196 350.023 59.1289 350.023 38.296C350.023 17.4631 333.654 0.57251 313.505 0.57251Z",
    fill: "#F4B350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorimg1);
export default __webpack_public_path__ + "static/media/Vectorimg1.2021e4316cbb0e3e4354cf27751121aa.svg";
export { ForwardRef as ReactComponent };